import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { Item } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/item.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';

const fetchItems = async (page: number, limit: number): Promise<Item[] | undefined> => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;

  const data = await getClient()?.searchItem(currentProject._id, {
    limit: limit || 100,
    page: page || 1
  });

  return data?.data;
};

export const useGetItems = ({ page, limit }: { limit: number; page: number }) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.EVENTS, page, limit], () => fetchItems(page, limit), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading Items data... Try again later', severity: 'error' });
    }
  });
};
